import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Estacoes from './pages/estacoes';
import Index from './pages/index';
import LocalizacaoChuvas from './pages/localizacao-chuvas';
import OutrasInformacoes from './pages/outras-informacoes';
import { Layout } from './layout';
import Contato from './pages/contato';
import PostosFluviometricos from './pages/postos-fluviometricos';

declare global {
  interface Window {
    initizalizeMobileToggle?: () => void;
  }
}

function App() {
  return (
    <div className="flex-fill">
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/estacoes" element={<Estacoes />} />
            <Route
              path="/niveis-rios-arroios"
              element={<PostosFluviometricos />}
            />
            <Route path="/localizacao-chuvas" element={<LocalizacaoChuvas />} />
            <Route path="/outras-informacoes" element={<OutrasInformacoes />} />
            <Route path="/contato" element={<Contato />} />
          </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
